import {CrossCurricurum} from "./CrossCurricurum";
import {Home} from "./Home";
import {Youtube} from "./Youtube";
import {StudyTour} from "./StudyTour";

window.AOS = require('aos');
require("@fancyapps/fancybox");
$.fancybox.defaults.animationEffect = 'fade';
$.fancybox.defaults.animationDuration = 200;

class App {
	
	static BREAK_POINT = 768;
	
	static init() {
		this.initNavi();
		this.initDefaultAnimation();
		$('._nav-cv a.is-top').click(this.scroll);
		this.iniutLoadingAddClass();
		window.addEventListener('load', this.initPreloadImages)
	}
	
	static initPreloadImages() {
		var count = 0;
		$('img[loading="lazy"]').each((index, el) => {
			count++;
			var img = new Image();
			img.dataset.element = el;
			img.element = el;
			img.onload = function (e) {
				count--;
				AOS.refresh();
			};
			img.src = el.src;
		});
	}
	
	static initNavi() {
		
		//タブレット
		if ('ontouchstart' in window) {
			$('.header-gnav__child a').click(e => {
				e.stopPropagation();
			});
			$('.is-parent').click(e => {
				if (!this.isSmartPhone()) {
					$('.is-parent').not(e.currentTarget).removeClass('is-open');
				}
				e.preventDefault();
				e.currentTarget.classList.toggle('is-open');
			});
			
		} else { //PC
			$('.is-parent').hover(e => {
				e.currentTarget.classList.add('is-open');
			}, e => {
				e.currentTarget.classList.remove('is-open');
			});
		}
		
		$(window).scroll(e => {
			if (window.scrollY > 100) {
				document.body.classList.add('is-scroll');
			} else {
				document.body.classList.remove('is-scroll');
			}
		}).trigger('scroll');
		
		var btn = document.querySelector('.header-btn');
		var scrollTop = 0;
		var open = function () {
			scrollTop = window.scrollY;
		}
		var close = function () {
			window.scrollTo(0, scrollTop);
		}
		btn.addEventListener('click', e => {
			var isOpen = document.body.classList.contains('is-menu-open');
			if (isOpen) {
				document.body.classList.remove('is-menu-open');
				close();
			} else {
				open();
				document.body.classList.add('is-menu-open');
			}
		});
		
		
		var footerHeads = document.querySelectorAll('.footer-page__head');
		footerHeads.forEach(el => {
			el.addEventListener('click', e => {
				if (App.isSmartPhone()) {
					e.preventDefault();
					e.currentTarget.closest('.footer-page__block').classList.toggle('is-open');
				}
			});
		});
		
		$('.header-gnav__link[href^="#"]').click(this.scroll);
		
	}
	
	static scroll(e,dulation){
		if(typeof dulation == 'undefined'){
			dulation = 1000;
		}
		e.preventDefault();
		var $el = $(e.currentTarget.getAttribute('href'));
		if($el.length==0) return;
		App.scollCore($el,dulation);
	}
	
	static scollCore($el,dulation){
		if(typeof dulation == 'undefined'){
			dulation = 1000;
		}
		document.body.classList.remove('is-menu-open');
		var top = $el.offset().top;
		var headerHeight = $('.header').outerHeight();
		if(!window.app.isSmartPhone()){
			var navLink = $('._nav-link');
			if(navLink.length){
				headerHeight+=navLink.outerHeight();
			}
		}
		
		var scrollTop = top - headerHeight;
		$('html,body').animate({scrollTop: scrollTop}, dulation,function(){
			var newScrollTop = $el.offset().top;
			newScrollTop-=headerHeight;
			if(Math.abs(scrollTop-newScrollTop) > 1){
				App.scollCore($el,10);
			}else{
			}
		});
	}
	
	static initDefaultAnimation() {
		var offset = (this.isSmartPhone())? 150: 150;
		AOS.init({
			delay: 0,
			once: true,
			duration: 1500,
			offset: offset,
			easing: "ease-out-quart"
		});
		setInterval(()=>{
			AOS.refresh();
		},1000);
	}
	
	static isSmartPhone() {
		const mediaQuery = window.matchMedia('(max-width: ' + App.BREAK_POINT + 'px)')
		if (mediaQuery.matches) {
			return true;
		}
		return false;
	}
	
	static initLoading(callBack) {
		var body = document.querySelector('body');
		window.addEventListener('load', e => {
			callBack.apply();
		});
		setTimeout(() => {
			callBack.apply();
		}, 5000);
	}
	
	static iniutLoadingAddClass(){
		var body = document.querySelector('body');
		window.addEventListener('load', e => {
			body.classList.add('is-loaded');
		});
		setTimeout(() => {
			body.classList.add('is-loaded');
		}, 5000);
	}
	
	
	static initStudyTour() {
		Youtube.checkAccess();
		this.initedStudyTour = false;
		this.initLoading(this.initStudyTourCallBack.bind(this));
	}
	
	static initStudyTourCallBack() {
		if (this.initedStudyTour) {
			return;
		}
		this.initedStudyTour = true;
		new StudyTour(this);
	}
	
	
	static initCrossCurriculum() {
		Youtube.checkAccess();
		this.initedCrossCurriculum = false;
		this.initLoading(this.initCrossCurriculumCallBack.bind(this));
	}
	
	static initCrossCurriculumCallBack() {
		if (this.initedCrossCurriculum) {
			return;
		}
		this.initedCrossCurriculum = true;
		setTimeout(() => {
			new CrossCurricurum(this);
		}, 2000);
	}
	
	
	static initHome() {
		Youtube.checkAccess();
		this.initedHome = false;
		this.initLoading(this.initHomeCallBack.bind(this));
	}
	
	static initHomeCallBack() {
		if (this.initedHome) {
			return;
		}
		setTimeout(() => {
			new Home(this);
		}, 2000);
		this.initedHome = true;
	}
	
	static initFacility(){
		if ('ontouchstart' in window || navigator.maxTouchPoints) {
			$('.facility-map__num').click((e)=>{
				var num = e.currentTarget.dataset.num;
				$('.facility-map__info').hide();
				$('.facility-map__info[data-num="'+num+'"]').fadeIn(600);
			});
			$('.facility-map__info:nth-child(1)').fadeIn(600);
		}
	}
	
	static initHashAutoScroll(){
		setTimeout(()=>{
			var hash = location.hash;
			if(hash == '') return;
			var $el = $(hash);
			App.scollCore($el,500);
		},1500);
	}
	
	static initLearning(){
		var win = $('.learning-tree__win');
		var winIndex = 0;
		var winTtl = $('.learning-tree__win-ttl');
		var winCopy = $('.learning-tree__win-copy');
		var winBody = $('.learning-tree__win-body');
		if ('ontouchstart' in window || navigator.maxTouchPoints) {
			$('.learning-tree__tent').click((e)=>{
				var num = e.currentTarget.dataset.num;
				var $target = $(e.currentTarget);
				winIndex = e.currentTarget.dataset.index;
				winTtl.text(e.currentTarget.dataset.ttl);
				winCopy.text(e.currentTarget.dataset.copy);
				winBody.text(e.currentTarget.dataset.body);
				win.removeClass('is-red is-yellow');
				if(winIndex < 7){
					win.addClass('is-red');
				}else{
					win.addClass('is-yellow');
				}
				win.addClass('is-show');
			});
		}else{
			
			$('.learning-tree__tent').hover((e)=>{
				var $target = $(e.currentTarget);
				winIndex = e.currentTarget.dataset.index; 
				winTtl.text(e.currentTarget.dataset.ttl);
				winCopy.text(e.currentTarget.dataset.copy);
				winBody.text(e.currentTarget.dataset.body);
				win.removeClass('is-red is-yellow');
				if(winIndex < 7){
					win.addClass('is-red');
				}else{
					win.addClass('is-yellow');
				}
				win.css({
					'margin-left': 'calc(' + $target.css('margin-left') + ' + ' + $target.width() * 1.2 + 'px)',
					'margin-top': 'calc(' + $target.css('margin-top') + ' - ' + $target.height() * 2 + 'px)'
				});
				win.addClass('is-show');
				
			},(e)=>{
				win.removeClass('is-show');
			});		
		}
	}
	
	
	static initTextAnimation(elements) {
		
		if (this.isSmartPhone()) {
			elements = elements.not('.pc');
		} else {
			elements = elements.not('.sp');
		}
		
		elements.each(function () {
			var $this = $(this);
			var delay = $this.attr('data-aos-delay');
			if(typeof delay == 'undefined'){
				delay = 0;
			}else{
				delay = parseInt(delay);
			}
			var text = $this.text().trim();
			var textbox = "";
			var cnt = 0;
			var step = 70;
			text.split('').forEach(function (t, i) {
				if (t == '\n') {
					textbox += "<br>";
					cnt += 5;
				} else if (
					t !== "\t"
				) {
					if (t == " ") {
						t = "&nbsp;";
					}
					var value = (cnt++ * step) + delay;
					textbox += '<span style="transition-delay:' + value + 'ms;">' + t + '</span>';
				}
			});
			$this
			.html(textbox)
			.addClass('aos-init-text-split');
		});
	}
}


App.init();
window.app = App;

// $('.cc-mv,.cc-nav,#about,#junior,#output,#highschool').hide();
// $('.h-mv,.h-banner,.h-first,.h-info,.h-igs,.h-teaching').hide();
// $('.st-mv').hide();
// document.getElementById('front-loader-bg').style.display = 'none';
// document.body.classList.add('is-loaded');
// document.body.classList.add('is-menu-open');